module.exports = __webpack_public_path__ + "static/media/hands-gray.b4892f6c.webp";